import React, {useEffect} from 'react'
import { useMediaQuery } from 'react-responsive';
import { LayoutContext } from 'components/app-routes';
import {  redirectToHome, } from '__utils/common-utils';
import MobileFooterLayout from 'components/old-footer-layout';
import Footer from 'components/footer';
import { privacyPolicyConstantsList,privacyPolicyConstantsItems } from './privacypolicyconstants';


const PrivacyPolicy: React.FC = () => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);

    useEffect(() => {
        SetLayoutProps({
            config: {
                goBackCallback: () => redirectToHome(),
                title: <span>PRIVACY POLICY</span>,
            },
            showBseInfoForDesktop: false,
            showCopyrightInfoForDesktop: true,
            breadcrumbList:[{text:'Home',url:'v1/home', isExternal:true},{text:'Privacy Policy',url:''}]
            
        });
    }, []);

    return(
        <>
            <div className={!isMobile?'staticoutercontainer':''}>
            </div>
            <div className={!isMobile?"staticinnerContainer":""}>
                {!isMobile && <section className='staticPageHead group'>
                    <h1>Privacy Policy</h1>
                    </section>}
                <div className={!isMobile?'':'aboutUS staticPg'}>
                    <div className={!isMobile?'':'singleAbout'}>
                    <section className={!isMobile?"staticPage":"container-fluid"}>
                    <p>Please read the following to learn more about our privacy policy. By using our website, you expressly
                give us your consent to use and disclose the information provided by you. If you do not agree to the
                terms, you are requested not to use or access our website.</p>
                {privacyPolicyConstantsList.map((item:privacyPolicyConstantsItems,id:number)=>
                <div key={id}>
                <h2>{item.h2tag}</h2>


                {item?.h4tag && <h4>{item.h4tag}</h4>}
                {item?.ptag && item.ptag.map((item,id:number)=>
                    <p key={id}>{item}</p>
                )}
                { item?.ultag && <ul>
                    {item.ultag.map((item,id:number)=>
                        <li dangerouslySetInnerHTML={{ __html: item}} key={id}></li>
                    )}
                </ul>}
                </div>

                )}  
                    </section>

                    </div>
                </div>
            </div>
            {isMobile &&
            <Footer>
                <MobileFooterLayout />
            </Footer>
        }
        </>
    )
};

export default PrivacyPolicy
